import React, {useEffect} from 'react';
import { connect } from "react-redux";
import {hideMessage} from '../../actions/toastmessage';
import AnimateOnHover from 'jd-library/AnimateOnHover'
import styles from "./toast-message.scss"

let prevTimeout = null;
const ToastMessage = props => {

    useEffect(() => {
        if(props.showToastMessage){
            prevTimeout = setTimeout(() => {
                props.hideMessage({
                    showToastMessage: false
                }); 
                if(props.onHiddenCb){
                    setTimeout(() => {
                        props.onHiddenCb && props.onHiddenCb();
                    }, 150)
                } 
            },props.duration || 3000);
        } else{
            prevTimeout && clearTimeout(prevTimeout);
        }
    },[props.showToastMessage]);

    let buttonObj;
    if(props.hasUndo) {
        buttonObj = {
            text: 'UNDO',
            icon: 'icon-revertChange',
            onClick: () => {
                props.onUndoClick && props.onUndoClick();
                props.hideMessage({
                    showToastMessage: false
                });
            }
        };
    }

   return(
        <div className={`toast-msg-div jd-font-roboto ${props.showToastMessage ? 'show-msg' : 'hide-msg'}`} style={{bottom: props.showToastMessage ? props.bottom : ''}}>
            <div className="toast-msg">
                <div className="toast-info two-line-ellipsis">
                    <div className = "msg-div">{props.message}</div>
                </div>
                {buttonObj && (
                    <AnimateOnHover 
                        className={'button-wrapper'}
                        onClick={buttonObj.onClick}>
                        {buttonObj.icon && <i className={`${'button-icon'} ${buttonObj.icon}`}></i>}
                        <span className={'button-text'}>{buttonObj.text}</span>
                    </AnimateOnHover>
                )}
            </div>
        </div>
   );
};

const mapStateToProps = ({toastMessage}) => {
    return {
        ...toastMessage
    };
  };
  
  export default connect(mapStateToProps, {
         hideMessage
  })(ToastMessage);